import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import StuTestHistoryComp from "./Component/StuTestHistoryComp"


const StuTestHistory =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <StuTestHistoryComp />
        </div>
        <Footer />
        </>
    )
}

export default StuTestHistory